import React, { useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Plus } from 'react-feather';
import {ApiDetails, KEY} from "../../Constants";

import ProblemTypeList from './ProblemTypeList';
import ProblemTypeDialog from './ProblemTypeDialog';
import CryptoJS from "crypto-js";
import { handle401Unauthorized, handle403Forbidden } from '../../utils/authErrorHandler';


const ProblemTypeSection = ({
                                problemTypes,
                                getLandlordId,
                                showAlert,
                                onProblemTypesUpdated
                            }) => {
    const [problemTypeDialogOpen, setProblemTypeDialogOpen] = useState(false);
    const [selectedProblemType, setSelectedProblemType] = useState(null);
const [originalText, setOriginalText] = useState(() => {
    const encryptedData = localStorage.getItem("myMap");
    return encryptedData 
        ? CryptoJS.AES.decrypt(encryptedData, KEY).toString(CryptoJS.enc.Utf8)
        : "";
});;

    // Add or update problem type
    const handleSaveProblemType = async (problemType, isNew) => {
        try {
            const landlordId = getLandlordId();
            if (!landlordId) return;

            const endpoint = isNew
                ? ApiDetails + "pegasus/visionary/tickets/api/tickets/problem-types/add"
                : ApiDetails + "pegasus/visionary/tickets/api/tickets/problem-types/update";

            const problemTypeData = {
                ...problemType,
                landlord_id: landlordId
            };

            const response = await fetch(endpoint, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "token": JSON.parse(originalText)[15][0] !== 'access_token' ? JSON.parse(originalText)[28][1] : JSON.parse(originalText)[15][1]
                },
                body: JSON.stringify(problemTypeData)
            });

             // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
            if (response.status === 200) {
                showAlert(isNew ? "Problem type added successfully" : "Problem type updated successfully");
                onProblemTypesUpdated();
                setProblemTypeDialogOpen(false);
                setSelectedProblemType(null);
            } else {
                throw new Error(`Error: ${response.status}`);
            }
        } catch (error) {
            console.error("Error saving problem type:", error);
            showAlert(isNew ? "Failed to add problem type" : "Failed to update problem type", "error");
        }
    };

    // Delete problem type
    const handleDeleteProblemType = async (problemTypeId) => {
        try {
            const landlordId = getLandlordId();
            if (!landlordId) return;

            const response = await fetch(ApiDetails + "pegasus/visionary/tickets/api/tickets/problem-types/delete", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "token": JSON.parse(originalText)[15][0] !== 'access_token' ? JSON.parse(originalText)[28][1] : JSON.parse(originalText)[15][1]
                },
                body: JSON.stringify({
                    problem_type_id: problemTypeId,
                    landlord_id: landlordId
                })
            });

             // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
            if (response.status === 200) {
                showAlert("Problem type deleted successfully");
                onProblemTypesUpdated();
            } else {
                throw new Error(`Error: ${response.status}`);
            }
        } catch (error) {
            console.error("Error deleting problem type:", error);
            showAlert("Failed to delete problem type", "error");
        }
    };

    return (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Typography variant="h6">Problem Types</Typography>
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<Plus size={16} />}
                    onClick={() => {
                        setSelectedProblemType(null);
                        setProblemTypeDialogOpen(true);
                    }}
                    sx={{ borderRadius: '8px', textTransform: 'none' }}
                >
                    Add Problem Type
                </Button>
            </Box>

            <ProblemTypeList
                problemTypes={problemTypes}
                onEdit={(problemType) => {
                    setSelectedProblemType(problemType);
                    setProblemTypeDialogOpen(true);
                }}
                onDelete={handleDeleteProblemType}
            />

            <ProblemTypeDialog
                open={problemTypeDialogOpen}
                problemType={selectedProblemType}
                onClose={() => {
                    setProblemTypeDialogOpen(false);
                    setSelectedProblemType(null);
                }}
                onSave={handleSaveProblemType}
            />
        </Box>
    );
};

export default ProblemTypeSection;